/**
 * Breadcrumb for Channel Documents folder navigation.
 */
import React from "react";
import { Stack, Link } from "@fluentui/react";

/**
 * @param {{
 *   folderStack: Array<{ id: string, name: string }>,
 *   rootLabel: string,
 *   theme: object,
 *   onNavigateToRoot: () => void,
 *   onNavigateToIndex: (index: number) => void,
 * }} props
 */
export function CheckInNewFolderBreadcrumb({
  folderStack,
  rootLabel,
  theme,
  onNavigateToRoot,
  onNavigateToIndex,
}) {
  if (!folderStack?.length) {
    return null;
  }

  return (
    <Stack
      horizontal
      verticalAlign="center"
      wrap
      tokens={{ childrenGap: 4 }}
      styles={{
        root: {
          padding: "8px 12px 4px",
          fontFamily: theme.fonts.regular,
          fontSize: theme.fontSizes.small,
          color: theme.colors.fontColor,
        },
      }}
    >
      <Link onClick={onNavigateToRoot} styles={{ root: { fontSize: "inherit" } }}>
        {rootLabel}
      </Link>
      {folderStack.map((folder, index) => (
        <Stack key={folder.id} horizontal verticalAlign="center" tokens={{ childrenGap: 4 }}>
          <span aria-hidden="true" style={{ color: theme.colors.fontColor, opacity: 0.6 }}>
            /
          </span>
          {index === folderStack.length - 1 ? (
            <span style={{ fontWeight: 600 }}>{folder.name}</span>
          ) : (
            <Link
              onClick={() => onNavigateToIndex(index)}
              styles={{ root: { fontSize: "inherit" } }}
            >
              {folder.name}
            </Link>
          )}
        </Stack>
      ))}
    </Stack>
  );
}
